import TitleBox from "@/components/title.vue";
import RealCase from "@/components/real-case.vue";
export default {
  name: "Index",
  components: {
    TitleBox,
    RealCase,
  },
  data() {
    return {
      bannerList: [
        require("@/assets/banner/banner1.png"),
        require("@/assets/banner/banner2.png"),
        require("@/assets/banner/banner3.jpg"),
        require("@/assets/banner/banner4.jpg"),
        require("@/assets/banner/banner5.jpg"),
        // require("@/assets/banner/banner6.png"),
      ],
      intelligent: [
        {
          content:
            "技术基础持续夯实<br>移动支付普及率已突破86%<br>AI、物联网等智能技术加速迭代",
          img: require("@/assets/cooperation-join/intelligent-bg1.png"),
        },
        {
          content:
            "实体经济成本一路攀高<br>国内员工薪酬持续稳健增长态势<br>企业降本压力持续增大",
          img: require("@/assets/cooperation-join/intelligent-bg2.png"),
        },
      ],
      automationUl: [
        {
          content: "消费者体验提升",
          img: require("@/assets/cooperation-join/automation1.png"),
        },
        {
          content: "新型支付场景",
          img: require("@/assets/cooperation-join/automation2.png"),
        },
        {
          content: "行业效率提升",
          img: require("@/assets/cooperation-join/automation3.png"),
        },
        {
          content: "线下流量人口",
          img: require("@/assets/cooperation-join/automation4.png"),
        },
      ],
      automationContent: {
        img: require("@/assets/cooperation-join/automation-content.png"),
        title: "最先拥抱智能化转型的行业具备以下特征",
        content: ["人力附加值低，现有体验差", "行业利润厚", "玩家分散"],
      },
      // 打印优势
      printAdvantages: [
        {
          img: require("@/assets/college/advantage1.png"),
          title: "7×24小时服务",
          desc: "随时随地上传，分组内任意设备取件",
        },
        {
          img: require("@/assets/convenience/advantage1.png"),
          title: "操作简单",
          desc: "微信小程序下单，无需下载APP",
        },
        {
          img: require("@/assets/convenience/advantage2.png"),
          title: "功能多样",
          desc: "文档、照片、证卡一站式服务",
        },
        {
          img: require("@/assets/convenience/advantage3.png"),
          title: "运维高效",
          desc: "成熟专业的运维团队",
        },
        {
          img: require("@/assets/college/advantage3.png"),
          title: "勤工俭学",
          desc: "提供勤工俭学兼职运维岗位",
        },
        {
          icon: "📡",
          title: "联网",
          desc: "支持无线和有线两种联网方式，适应各种投放环境",
        },
        {
          icon: "🔒",
          title: "安全",
          desc: "反编译系统，更安全，更可靠",
        },
        {
          icon: "⚡",
          title: "稳定",
          desc: "工业化微电子工艺技术，即插即用",
        },
      ],
      // 真实案例轮播图
      realCaseList: [
        require("@/assets/realcase/live1.jpg"),
        require("@/assets/realcase/live2.jpg"),
        // require("@/assets/realcase/live3.png"),
        require("@/assets/realcase/live4.png"),
        require("@/assets/realcase/live5.png"),
        require("@/assets/realcase/live6.png"),
        require("@/assets/realcase/live7.jpg"),
        require("@/assets/realcase/live8.jpg"),
      ],
    };
  },
  computed: {},
  methods: {
    toAboutUsPage() {
      this.$router.push("/about-us");
    },
  },
};
